const KEY_PREFIX = "smartscan_inventory_data";
const keyFor = (uid) => (uid ? `${KEY_PREFIX}_${uid}` : KEY_PREFIX);

export const loadLocal = (uid) => {
  try {
    const raw = localStorage.getItem(keyFor(uid));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveLocal = (uid, items) => {
  try {
    localStorage.setItem(keyFor(uid), JSON.stringify(items));
  } catch {
    /* ignore quota */
  }
};

export const exportCsv = (items, fieldDefs = []) => {
  const enabled = (fieldDefs || []).filter((f) => f.enabled);
  const fieldLabel = (f, i) =>
    f.label && f.label.trim() ? f.label.trim() : `Detail ${i + 1}`;
  const headers = [
    "ID",
    "Timestamp",
    "Item Name",
    "Description / Attributes",
    "Category",
    "Quantity",
    "Extracted Text",
    ...enabled.map((f, i) => fieldLabel(f, i)),
    "Source Image",
  ];
  const esc = (v) => {
    let s = String(v ?? "");
    // Neutralize spreadsheet formula injection (CWE-1236)
    if (/^[=+\-@\t\r]/.test(s)) s = "'" + s;
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const rows = items.map((it) =>
    [
      it.id,
      it.timestamp,
      it.item_name,
      it.description,
      it.category,
      it.quantity,
      it.extracted_text || "",
      ...enabled.map((f) => (it.fields && it.fields[f.id]) || ""),
      it.source_image_url || "",
    ]
      .map(esc)
      .join(",")
  );
  const csv = [headers.join(","), ...rows].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `smartscan-inventory-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
